export default "__VITE_ASSET__BTtsi_e3__"